// add these imports at the top
import React from 'react';
import { TelephoneFill } from 'react-bootstrap-icons';

/* helper: turn any value into a clean string[] */
const parseStatus = raw => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  try { return JSON.parse(raw); } catch { return [String(raw)]; }
};

const cleanPhone = value => {
  const phone = String(value ?? '').trim();
  return /^(null|undefined)$/i.test(phone) ? '' : phone;
};

const getMessagePhone = row =>
  cleanPhone(
    row?.senderMobileNumber ||
    row?.phoneNumber ||
    row?.mobileNumber ||
    row?.phone ||
    '',
  );

const toTelHref = value => {
  const phone = cleanPhone(value);
  if (!phone) return '';

  const prefix = phone.startsWith('+') ? '+' : '';
  const digits = phone.replace(/\D/g, '');
  return digits ? `tel:${prefix}${digits}` : '';
};

/* DB‑row → react‑chat‑elements item */
export const mapRow = (
  row,
  me          = 'Me',
  building    = '',
  myLocation  = '',
  statusesRaw = []          // <- may be [], string, JSON, null, etc.
) => {
  if (!row) return null;

  /* ---------------------------------------------------------------- */
  const statusArr = Array.isArray(statusesRaw)
    ? statusesRaw
    : parseStatus(statusesRaw);          // <‑─ always an array now
  /* ---------------------------------------------------------------- */

  const mine   = (row.senderName || me) === me;
  const mobile = getMessagePhone(row);
  const telHref = toTelHref(mobile);

  let type = 'text', data;
  if (row.attachmentURL) {
    if (row.attachmentType === 'Photo') {
      type = 'photo';
      data = { uri: row.attachmentURL };
    } else {
      type = 'file';
      data = {
        link    : row.attachmentURL,
        fileName: row.attachmentURL.split('/').pop(),
      };
    }
  }

  const title = (
    <div>
      {/* name + tel ‑‑––––––––––––––––––––––––––––––––––––––––──────── */}
      <div className="d-flex align-items-center gap-1">
        {telHref && (
          <a
            href={telHref}
            onClick={e => e.stopPropagation()}
            title={`Call ${mobile}`}
            aria-label={`Call ${row.senderName || 'message sender'} at ${mobile}`}
            style={{ textDecoration:'none' }}
          >
            <TelephoneFill size={12}/>
          </a>
        )}
        {row.senderName || (mine ? me : 'Unknown')}
      </div>

      {/* building | room –––––––––––––––––––––––––––––––––––––––––––– */}
      <div style={{ fontSize:'0.75em', color:'#666', marginTop:2 }}>
        {(building || '—')}
        {myLocation ? ` | ${myLocation}` : ''}
      </div>

      {/* latest status line (safe) –––––––––––––––––––––––––––––––––– */}
      {statusArr.length > 0 && (
        <div style={{ fontSize:'0.75em', color:'#007bff', marginTop:2 }}>
          {statusArr.join(', ')}
        </div>
      )}
    </div>
  );

  return {
    position: mine ? 'right' : 'left',
    type,
    text : row.messageText || (row.attachmentURL ? row.attachmentType : ''),
    data,
    title,
    date : row.createdAt ? new Date(row.createdAt) : new Date(),
  };
};